import * as React from 'react';
/**
 *
 * Original name: upload file
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A306
 *
 */
export const UploadFilePictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "m49.242 15.414-5.656-5.656A5.96 5.96 0 0 0 39.343 8H13v48h38V19.657a5.958 5.958 0 0 0-1.758-4.243ZM17 52V12h21v9h9v31H17Z", fill: "currentColor" }),
    React.createElement("path", { d: "M34 28h-4a11.352 11.352 0 0 1-5.895 6.211l1.789 3.578A16.773 16.773 0 0 0 30 34.926V46h4V34.926a16.774 16.774 0 0 0 4.105 2.864l1.789-3.578A11.347 11.347 0 0 1 34 28Z", fill: "currentColor" })));
